import { CommonModule } from '@angular/common';
import {Component, Input} from '@angular/core';
import {AdditionalPACData, PaymentCategory, PaymentFrequency} from '../../models/additional-pac-data.model';
import { AppConstants} from '../../shared/app-constants';


@Component({
  selector: 'app-pac-detail',
  imports: [CommonModule],
  templateUrl: './pac-detail.component.html',
  styleUrl: './pac-detail.component.scss',
  standalone: true
})
export class PacDetailComponent {

  @Input() pacDetails!: AdditionalPACData;

  showAmountFormatted(value: number | null | undefined): string {
    return AppConstants.showAmountFormatted(value);
  }

  isCourtPayment() {
    return this.pacDetails.paymentCategory === PaymentCategory.COURT_PAYMENT;
  }

  isInstalmentPayment(){
    return this.pacDetails.paymentFrequency === PaymentFrequency.I;
  }

  get pacNumberWithoutPrefix(): string | undefined {
    const pacNumber = this.pacDetails.pacNumber;
    if (pacNumber?.startsWith('PAC')) {
      return pacNumber?.substring(3);
    }
    return pacNumber;
  }
}
